<template>
  <div class="MediaDetail">
    <div class="top-nav-bar">
      <van-navBar :title="pageTitle" left-text="返回" left-arrow @click-left="goCourseDetails">
      </van-navBar>
    </div>
    <!-- 按钮菜单 -->
    <!--<div class="btn" v-show="btnShow" @click="handleBtn"></div>-->
    <!--<div class="backCourseDetails" @click="goCourseDetails">返回课程</div>-->
    <div class="showMenuBtn" @click="handleBtn">课程目录</div>
    <!--<van-button type="success">课程目录</van-button>-->
    <!-- 列表弹出层 -->
    <van-popup class="popup"
      :class="{isWhite:active!==''}"
      v-model="popupShow"
      :position="popupProp.position"
      @close="popupClose"
      :style="{width:popupProp.width,height:popupProp.height}"
    >
      <div class="header">课程目录</div>
      <div class="list">
        <div class="item" v-for="(item,index) in chapters" :key="index">
          <div class="top">
            <div class="line"></div>
            <div class="title">{{ item.name }} <span class="tagActive" v-if="item.isBuy && item.aloneSale && !detail.free">已购</span></div>
          </div>
          <div v-if="item.annexes.length===0" class="list_none">暂无内容</div>
          <div
            class="row"
            v-else
            v-for="(row,i) in item.annexes"
            :key="i"
            @click="handleRow(row)"
            :class="{'active':annexId*1 === row.id}"
          >
            <div class="icon" :class="fileIcon[row.fileType]"/>
            <div class="value">{{ row.name }}</div>
            <span class="tagActive" v-if="row.isBuy && row.aloneSale && !detail.free">已购</span>
            <template v-if="!row.isBuy && row.isTryView && !detail.isFree">
              <span class="tagActive"  v-if="row.fileType === 2">试听</span>
              <span class="tagActive" v-else>可试看</span>
            </template>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 音频 -->
<!--    <audio class="audio" controlsList="nodownload" controls :src="detail.path" v-if="detail.fileType === 2"></audio>-->
    <vue-audio
      style="margin-top: 20%"
      v-if="detail.fileType === 2"
      v-bind:audio-source="detail.path"
    ></vue-audio>



    <!-- 视频：20230802为保障苹果手机的使用，不使用ckplayer，而使用H5原生的video标签播放视频 -->
    <!--<div id="video" v-if="detail.fileType === 3"></div>-->
    <div v-if="detail.fileType === 3" style="text-align: center">
      <video style="width: 80%;height: auto;border: solid 1px #555;border-radius: 10px;text-align: center"  controls :src="detail.path" controlsList="nodownload" autoplay="true"></video>
    </div>
    <!--文件预览-->
    <iframe class="word" v-if="detail.fileType === 4 || detail.fileType === 5 || detail.fileType === 6 || detail.fileType === 7 || detail.fileType === 8"
    :src="`${iframeUrl}&furl=${detail.path || ''}`" :key="detail.id"></iframe>
    <!-- 图片 -->
    <van-image class="vanImg" v-if="detail.fileType === 10" fit="contain" :src="detail.path" @click="lookImage(detail.path)"></van-image>
    <!--富文本-->
    <div class="rich rich-text" v-if="detail.fileType === 0" v-html="detail.content"></div>
  </div>
</template>

<script>
import { NavBar, ImagePreview, Dialog } from 'vant';
import { mapGetters } from 'vuex';
import aplayer from "vue-aplayer";

// const { media } = this.$refs.aplayer;
export default {
  name: 'MediaDetail',
  components: {
    'van-navBar': NavBar,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Dialog.Component.name]: Dialog.Component,
    aplayer
  },
  data () {
    return {
      pageTitle: '课程详情',
      btnShow: true,
      popupShow: false,
      detail: {},
      chapters: [],
      activeIndex: '',
      iframeUrl: '',
      annexId: '', // 具体详情id
      courseId: '', // 课程id
      active: '',
      popupProp: {
        position: 'bottom',
        width: '100%',
        heigth: '60%'
      },

      api: {
        0: 'course',
        1: 'lesson'
      },

      fileIcon: {
        0: 'icon-1', // 文件
        1: 'icon-3', // pdf
        2: 'icon-7', // MP3
        3: 'icon-4', // 视频
        4: 'icon-8', // 压缩包
        5: 'icon-3', // pdf
        6: 'icon-5', // ppt
        7: 'icon-6', // word
        8: 'icon-9', // execl
        9: 'icon-10', // 其他
        10: 'icon-2' // 文件
      },
      audioList:[],
      nfclass_audio_bg: "https://gjs-resourse.oss-cn-shenzhen.aliyuncs.com/resources/20230831/nfclass_audio_bg.png"
    };
  },
  watch: {
    $route: {
      handler ({ name, query = {} }) {
        this.$nextTick(() => {
          if (name === 'MediaDetail') {
            this.getIframe();
            this.pageTitle = query.title || '课程详情';
            this.getDetail();
          }
        });
      },
      immediate: true
    }
  },
  mounted () {

    const { $route: { query } } = this;
    this.courseId = query.courseId;
    this.annexId = query.annexId;
    this.active = query.active;
    window.addEventListener('resize', this.resize, false);
    // console.log("courseId",this.courseId)
    this.getFreeCourseIds();
    // console.log("userInfo",this.userInfo)

  },
  computed: {
    // 获取用户信息
    ...mapGetters(['personInfo']),
    userInfo () {
      const { personInfo: { user } } = this;
      return user || {};
    }
  },
  beforeDestroyed () {
    window.addEventListener('resize', this.resize, false);
  },
  methods: {
    playAudio(e){
      console.log("play")
      this.nfclass_audio_bg = "https://gjs-resourse.oss-cn-shenzhen.aliyuncs.com/resources/20230831/nfclass_audio_bg.gif"
    },
    stopAudio(){
      // 暂停音频
      console.log("stop")
      this.nfclass_audio_bg = "https://gjs-resourse.oss-cn-shenzhen.aliyuncs.com/resources/20230831/nfclass_audio_bg.png"
    },
    pauseAudio(){
      console.log("pause")
      this.nfclass_audio_bg = "https://gjs-resourse.oss-cn-shenzhen.aliyuncs.com/resources/20230831/nfclass_audio_bg.png"
    },

    goCourseDetails(){
      // 返回课程详情介绍页
      this.$router.push({path:'/bookClassDetail',query: {id:this.courseId,active: 0}})
      // document.referrer === '' ?
      //   this.$router.push({path:'/bookClassDetail',query: {id:this.courseId,active: 0}}) :
      //   window.history.go(-1);
    },

    // 获取免费课程ids
    getFreeCourseIds(){
      const { $http, $utils, $router } = this;
      if (this.courseId) {
        $http.get('course/get/no/login/resource').then((res) => {
          console.log('结果', res);
          // 获取courseIds
          let courseIds = res.data.courseIds;
          console.log("courseIds",courseIds)
          // 判断当前
          let flag = courseIds.includes(Number(this.courseId));
          if (flag) {
            // 此时为免费课程
            this.getDetail();
          }else{
            // 此时为非免费课程，首先判断用户是否登录
            if (Object.keys(this.userInfo)==0){
              // 用户未登录
              // 这里执行跳转弹窗提示
              Dialog.confirm({
                title: '提示',
                message: '该课程需要登录才能查看，是否登录',
                confirmButtonText: '去登录',
              }).then(() => {
                // 点击确认按钮事件处理
                console.log("点击了确认按钮");
                $router.push({
                  name: 'Login',
                  query: { redirect: '/mediaDetail?active='+this.active+'&courseId='+this.courseId+'&annexId='+this.annexId } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
                });
              }).catch(() => {
                // 点击取消按钮事件处理
                history.go(-1);
              });
            } else{
              this.getDetail();
            }
          }
          this.$wxShare({
            // url: window.href, // 网址，默认使用 window.location.href
            title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
            desc: this.detail.content || '广东教育出版社 | 南方E课堂', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
            imgUrl: this.detail.image // 图片, 默认取网页中第一个img标签
          });
        }).catch((e) => {
          console.log("e", e);
        });
      } else {
        $utils.failToast({
          message: '信息为空',
          onClose: () => {
            $router.go(-1);
          }
        });
      }
    },

    /*  */
    getIframe () {
      this.$http.get('file/view').then((res) => {
        this.iframeUrl = res.data.url;
      });
    },

    /* 粤教培训/优秀课例的详情 */
    getDetail () {
      const { courseId, annexId, active, api } = this;
      this.$http.get(`${api[active]}/chapter/view`, {
        params: {
          courseId,
          annexId
        },
        showLoading: true
      }).then((res) => {
        this.chapters = res.data.chapters;
        this.handleRow(res.data);
      });
    },

    handleRow (data) {
      console.log("data",data)
      let { detail, $utils } = this;
      detail = data || {};
      this.annexId = detail.id;

      let videoItem;

      this.chapters.filter((item) => item.annexes.filter((itemCli) => {
        if (itemCli.id === data.id) {
          videoItem = itemCli;
        }
      }));
      console.log(videoItem);


      /* 没买 且没的试看试听情况下 */
      if (!videoItem.isBuy && !videoItem.isTryView) {
        if (data.aloneSale) {
          $utils.toast('请先购买课程或该章节');
        } else {
          $utils.toast('请先购买课程');
        }
        // console.log("courseId",this.courseId)
        // this.$router.push({path:'/bookBuy',query: {id:this.courseId,active: 0,type: 0}})
        Dialog.confirm({
          title: '提示',
          message: '该课程需要购买才能查看，是否购买',
          confirmButtonText: '去购买',
        }).then(() => {
          // 点击确认按钮事件处理
          this.$router.push({path:'/bookBuy',query: {id:this.courseId,active: 0,type: 0}})
        }).catch(() => {
          // 点击取消按钮
          this.goCourseDetails();
        });


        return false;
      }
      this.popupClose();

      this.detail = detail;

      // 视频
      if (data.fileType === 3) {
        // 20230802为保障苹果手机的使用，不使用ckplayer，而使用H5原生的video标签播放视频
        // this.$nextTick(() => {
        //   this.videoInit(data);
        // });
      }
    },

    /* 视频播放 */
    videoInit (data) {
      const { $utils, $router, active } = this;
      // 定义一个变量：videoObject，用来做为视频初始化配置
      const videoObject = {
        container: '#video', // “#”代表容器的ID，“.”或“”代表容器的class
        variable: 'player', // 播放函数名称，该属性必需设置，值等于下面的new ckplayer()的对象
        video: data.path, // 视频地址
        mobileAutoFull: false, // 移动端是否默认全屏播放
        loaded: 'window.loaderHandler'
      };
      // eslint-disable-next-line new-cap
      const player = new ckplayer(videoObject);// 初始化播放器
      let timer = null;
      window.loaderHandler = function (name) {
        player.addListener('time', window.timeHandle); // 监听元数据
      };

      let videoItem;
      this.chapters.filter((item) => item.annexes.filter((itemCli) => {
        if (itemCli.id === data.id) {
          videoItem = itemCli;
        }
      }));


      window.timeHandle = (time) => {
        const metaDate = player.getMetaDate();
        if (!metaDate.paused && data.tryViewTime && time > data.tryViewTime && !videoItem.isBuy) {
          if (Math.floor(time) > data.tryViewTime) {
            player.videoSeek(data.tryViewTime);
          }
          clearTimeout(timer);
          timer = setTimeout(() => {
            player.videoPause();// 控制视频播放
          }, 100);
          Dialog.confirm({
            title: '提示',
            message: '本节为付费内容，购买后才能观看',
            confirmButtonText: '购买'
          }).then(() => {
            // on confirm
            // 可以单独购买
            if (data.aloneSale) {
              $router.push({
                name: 'BookBuy',
                query: {
                  id: data.id,
                  type: 2,
                  active
                }
              });
              return false;
            }
            $utils.toast({
              message: '该内容不允许单独购买，请购买课程',
              onClose: () => {
                $router.go(-1);
              }
            });
          }).catch(() => {
            clearTimeout(timer);
            return false;
          });
        }
      };
    },

    /* 图片预览 */
    lookImage (path) {
      ImagePreview([
        path
      ]);
    },

    /* 打开弹层 */
    handleBtn () {
      this.btnShow = false;
      this.popupShow = true;
    },

    /* 关闭弹层 */
    popupClose () {
      this.popupShow = false;
      this.btnShow = true;
    },

    /* 判断手机处于横屏还是竖屏 */
    resize () {
      const { popupProp } = this;
      let width = document.documentElement.clientWidth;
      let heigth = document.documentElement.clientHeight;

      // 横屏
      if (width > heigth) {
        popupProp.position = 'left';
        popupProp.width = '60%';
        popupProp.heigth = '100vh';
      } else {
        popupProp.position = 'bottom';
        popupProp.width = '100%';
        popupProp.heigth = '60%';
      }
    }
  },
};
</script>

<style lang="less" scoped>
.MediaDetail {
  position: relative;
  height: calc(100vh - 94px);
  .showMenuBtn{
    width: 150px;
    height: 60px;
    background: #0286ff;
    font-size: 30px;
    color: #FFF;
    line-height: 60px;
    text-align: center;
    border-radius: 5px;
    position: fixed;
    bottom: 220px;
    right: 0;
  }
  .backCourseDetails{
    width: 150px;
    height: 60px;
    background: #0286ff;
    font-size: 30px;
    color: #FFF;
    line-height: 60px;
    text-align: center;
    border-radius: 5px;
    position: fixed;
    bottom: 200px;
    left: 0;
  }
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        width: 96px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
      }
    }
  }
  .audio {
    width: 100%;
  }
  #video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 600px;
  }
  .word {
    width: 100vw;
    height: 100%;
  }
  .rich {
    padding: 30px;
    width: 100%;
    background-color: #fff !important;
    font-size: 24px;
  }
  .vanImg {
    width: 100%;
  }
  .btn {
    position: fixed;
    width: 60px;
    height: 60px;
    right: 28px;
    bottom: 40px;
    background: url('~@/assets/images/study/icon_menu_01.png') no-repeat center center/cover;
    z-index: 10;
  }
  .popup {
    width: 100vw;
    height: 686px;
    background: rgba(0,0,0,.9);
    border-radius: 16px 16px 0px 0px;
    display: flex;
    flex-direction: column;
    .header {
      height: 128px;
      font-size: 36px;
      color: #fff;
      padding: 40px;
    }
    .list {
      flex: 1;
      height: 0;
      overflow: auto;
      padding: 0 40px;
      .item {
        margin-bottom: 40px;
        .top {
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          .line {
            width: 8px;
            height: 32px;
            background: #5FA9FF;
            border-radius: 4px;
          }
          .title {
            margin-left: 20px;
            font-size: 32px;
            color: #fff;
          }
        }
        .list_none{
          font-size: 30px;
          padding: 0 68px;
          color: #969799;
        }
        .row {
          padding: 15px 0;
          display: flex;
          align-items: center;
          .icon {
            width: 40px;
            height: 40px;
            .loop-icon(0,'fileIcon/icon_file',10);
          }
          .icon1 {
            width: 40px;
            height: 40px;
            .loop-icon(11,'fileIcon/icon_file',20);
          }
          .value {
            margin-left: 16px;
            font-size: 28px;
            font-weight: 500;
            color: #fff;
          }
          .active {
            color: #5FA9FF !important;
          }
          .tag {
            margin-left: 16px;
            width: 60px;
            height: 34px;
            border: 1px solid #FFFFFF;
            border-radius: 4px;
            font-size: 24px;
            font-weight: 500;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .tagActive {
          color: #5FA9FF !important;
          border: 2px solid #5FA9FF !important;
          font-size: 20px;
          margin-left: 12px;
          border-radius: 20px;
          padding: 4px 18px;
        }
      }
    }
  }
  .isWhite{
    background: #FFFFFF;
    .header{
      color: #333333;
      text-align: center;
      font-weight: bold;
    }
    .list{
      padding: 0;
      .item{
        .top{
          padding: 0 40px;
          .title{
            color: #333444;
            font-size: 30px;
            font-weight: bold;
            color: #333444;
          }
        }
        .row{
          padding-left: 40px;
          padding-right: 40px;
          .value {
            color: #67677A;
          }
          .tag {
            margin-left: 16px;
            width: 60px;
            height: 34px;
            border: 1px solid #FFFFFF;
            border-radius: 4px;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #67677A;
          }
        }
        .active {
         background: #EFF6FF !important;
        }
      }
    }
  }
  /deep/ .aplayer{
    position: fixed;
    bottom: 20px;
    width: 95%;
    left: 0;
    right: 0;
  }
  /deep/ .aplayer-music{
    color: #000;
    /*margin-top: -20px;*/
    line-height: 20px;
  }
}

#audio-viewer{
  font-size: .5rem;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

/deep/ .vueAudioBetter{
  width: 90% !important;
  font-size: 0.3rem;
}




</style>